module.exports = __webpack_public_path__ + "img/act_11_step5.ea9eb8cb.png";